<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Amex" class="d-icon d-icon--amex" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x=".25" y="3.75" width="23.5" height="16.5" rx="1.75" fill="#1F72CD" stroke="#E3E5E8" stroke-width=".5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.257 9.4 2 14.542h2.702l.335-.82h.766l.335.82h2.974v-.626l.265.626h1.539l.265-.639v.639h6.185l.753-.799.704.799 3.177.007-2.264-2.564L22 9.4h-3.128l-.732.784-.682-.784h-6.73l-.577 1.327L9.559 9.4H6.863v.604l-.3-.604H4.257Zm.523.73h1.317l1.497 3.487V10.13h1.443l1.157 2.5 1.065-2.5h1.436v3.69h-.873l-.008-2.891-1.273 2.89h-.782l-1.28-2.89v2.89H6.68l-.34-.826H4.5l-.34.826h-.963L4.78 10.13Zm12.266 0h-3.552v3.688h3.497l1.128-1.222 1.086 1.222h1.136l-1.651-1.833 1.65-1.855h-1.086l-1.121 1.208-1.087-1.208Zm-11.625.624-.607 1.474h1.212l-.605-1.473Zm8.95.814v-.674h2.217l.967 1.077-1.01 1.083h-2.174v-.736h1.938v-.75h-1.938Z" fill="#fff"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconAmex',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
